import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_DataObjectColumnRow, WB_DataObjectColumnTextRow,
    WB_DataObjectMessageRow,
    WB_DataObjectMessageTextRow,
    WB_DataObjectRow,
    WB_DataObjectTextRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbDataObject} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_DataObject,
    esWB_DataObject_Column,
    esWB_DataObject_Column_Text,
    esWB_DataObject_Message,
    esWB_DataObject_Message_Text,
    esWB_DataObject_Text,
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver, jsdRelation, Relation_BelongsTo} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";

import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ESRecordMapper} from "../PA.Core/lib/ESRecordMapper";
import {IColumnSchema, ISchema, TableCustomColumnsEntry} from "../PA.Core/PA.Core.IF.Entity";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";
import {LanguageText} from "../PA.Core/Basic/LanguageText";
import {PAEntity} from "../PA.Core/PAEntity";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";

export class DataObjectBO implements IBusinessObject {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_DataObject: WB_DataObjectRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New DataObject'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_DataObject = null;
        //this.IHaveTagsLoaded_init()
    }


    get WB_DataObject(): WB_DataObjectRow {
        return this.drWB_DataObject;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;

        this.LoadProgressProvider.start("Creating DataObject");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for new Data Object.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            self.dbContext.createRecordWithKey(esWB_DataObject)
                .then((newDataObjectRow: WB_DataObjectRow) => {
                    newDataObjectRow.setDefaults()
                    self.drWB_DataObject = newDataObjectRow;
                    self.dbContext.add(esWB_DataObject, newDataObjectRow)
                    self.Identity.setAll(self.WB_DataObject.cif.WB_DATAOBJECT_ID, self.WB_DataObject.cif.DATAOBJECT_ID, self.WB_DataObject.cif.DATAOBJECT_NAME);
                    self.Identity.listenToRecordUpdates(self.WB_DataObject, 'WB_DATAOBJECT_ID', 'DATAOBJECT_ID', 'DATAOBJECT_NAME')

                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                    return self._AfterBoLoadCompleteInternal()
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("DataObject already loaded.");
                self._OnLoadComplete = null;
                resolve(self);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for DataObject.")
                return;
            }


            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = DataObjectBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = DataObjectBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aDataObjectRow: any = recordResolver.get(esWB_DataObject, anId)

                    if (_.isEmpty(aDataObjectRow)) {
                        error("DataObject not found");
                        return;
                    }

                    self.drWB_DataObject = aDataObjectRow;
                    self.Identity.setAll(self.WB_DataObject.cif.WB_DATAOBJECT_ID, self.WB_DataObject.cif.DATAOBJECT_ID, self.WB_DataObject.cif.DATAOBJECT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_DataObject, 'WB_DATAOBJECT_ID', 'DATAOBJECT_ID', 'DATAOBJECT_NAME')

                })
                .then(() => {
                    return self._AfterBoLoadCompleteInternal()
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function (err: any) {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {

        const self = this;
        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_DataObject.cif.DATAOBJECT_NAME + "(" + self.WB_DataObject.cif.DATAOBJECT_ID + ")");

        self.ValidateOptions = options || {};
        try {
            if (_.isEmpty(self.dbContext)) {
                var sError = "Unable to determine dbContext for to Validate Data Object.";
                self.ValidateProgressProvider.exception(sError);
                return self;
            }

            // Validate Metric Columns
            let metricColumns = _.filter(self.WB_DataObject.WB_DataObjectColumnRows, (a) => a.isActive && a.cif.COLUMN_METATYPE == 'metric')
            _.forEach(metricColumns, (aRow) => {
                let cif = aRow.cif

                let visibleMetricNoAggregator = (aRow.bMetricVisibleInd && _.isEmpty(cif.METRIC_AGGR_METHOD.trim()))
                ErrorMessage_restate(self.ValidateMessageProvider, visibleMetricNoAggregator,
                    `${cif.COLUMN_ID}_Visible_NoAggr`, `Visible Metric ${cif.COLUMN_NAME} (${cif.COLUMN_ID}) has no Aggregator specified`)

                let bNumNoUOMForConverter = (!_.isEmpty(cif.UOM_CONVERTER_NUM.trim())) && _.isEmpty(cif.UOM_NUM.trim())
                let bDenomNoUOMForConverter = (!_.isEmpty(cif.UOM_CONVERTER_DENOM.trim())) && _.isEmpty(cif.UOM_DENOM.trim())

                ErrorMessage_restate(self.ValidateMessageProvider, bNumNoUOMForConverter,
                    `${cif.COLUMN_ID}_Num_Cnvtr_NoUOM`, `UOM not set for Converted Numerator ${cif.COLUMN_NAME} (${cif.COLUMN_ID})`)

                ErrorMessage_restate(self.ValidateMessageProvider, bDenomNoUOMForConverter,
                    `${cif.COLUMN_ID}_Denom_Cnvtr_NoUOM`, `UOM not set for Converted Denominator ${cif.COLUMN_NAME} (${cif.COLUMN_ID})`)

                let editableMetricNoPushdown = (aRow.bMetricEditableInd && (_.isEmpty(cif.METRIC_PUSHDOWN_METHOD.trim()) || (cif.METRIC_PUSHDOWN_METHOD == 'None')))
                ErrorMessage_restate(self.ValidateMessageProvider, editableMetricNoPushdown,
                    `${cif.COLUMN_ID}_Editable_NoPushdown`, `Editable Metric ${cif.COLUMN_NAME} (${cif.COLUMN_ID}) has no Push down Method specified`)

                ErrorMessage_restate(self.ValidateMessageProvider, _.isEmpty(cif.COLUMN_NAME.trim()),
                    `${cif.COLUMN_ID}_EmptyName`, `Metric ${cif.COLUMN_NAME} (${cif.COLUMN_ID}) has empty Name`)

                ErrorMessage_restate(self.ValidateMessageProvider, _.isEmpty(cif.METRIC_GROUP.trim()),
                    `${cif.COLUMN_ID}_EmptyGroupName`, `Metric ${cif.COLUMN_NAME} (${cif.COLUMN_ID}) has empty Group Name`)

            })


            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
        } catch (err) {
            self.ValidateMessageProvider.addMessage({
                code: 'Exception',
                type: MessageType.Error,
                description: JSON.stringify(err),
                title: 'Validation Exception'
            })
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
        }
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        self._bIsSaved = false
        const wbDataObject = <IwbDataObject>self.drWB_DataObject;
        self.SaveProgressProvider.start("Saving " + wbDataObject.DATAOBJECT_NAME + "(" + wbDataObject.DATAOBJECT_ID + ")");
        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (_.isEmpty(this.dbContext)) {
                let sError = "Unable to determine dbContext to Save DataObject.";
                self.SaveProgressProvider.exception(sError);
                return self
            }
            self.SaveOptions = options || {};

            await self.Validate(options)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self.SaveProgressProvider.finish();
                return self
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_DataObject, self.drWB_DataObject, {})

            let tasks: Promise<any>[] = []

            tasks.push(saveFunction(esWB_DataObject_Text, self.drWB_DataObject.WB_DataObjectTextRows))
            tasks.push(saveFunction(esWB_DataObject_Column, self.drWB_DataObject.WB_DataObjectColumnRows))
            tasks.push(saveFunction(esWB_DataObject_Column_Text, _.flatMap(self.WB_DataObject.WB_DataObjectColumnRows, (a) => a.WB_DataObjectColumnTextRows)))
            tasks.push(saveFunction(esWB_DataObject_Message, self.drWB_DataObject.WB_DataObjectMessageRows))
            tasks.push(saveFunction(esWB_DataObject_Message_Text, _.flatMap(self.WB_DataObject.WB_DataObjectMessageRows, (a) => a.WB_DataObjectMessageTextRows)))
            await Promise.all(tasks)
            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                })
            } else {
                self._bIsSaved = true;
            }
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbDataObject = <IwbDataObject>self.drWB_DataObject;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbDataObject.DATAOBJECT_NAME + "(" + wbDataObject.WB_DATAOBJECT_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the DataObject

            // 2. If Valid, mark all the records for deletion.
            self.drWB_DataObject.markDeleted()
            _.forEach(self.drWB_DataObject.WB_DataObjectTextRows, (esc: WB_DataObjectTextRow) => {
                if (esc.isActive) {
                    esc.markDeleted()
                }
            })

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        let tasks: Promise<any>[] = [];
        self.LoadProgressProvider.setProgressMessage('DataObjectBO.PostLoad', 'Processing Loaded Data');
        tasks.push(self.IHaveLanguageText_OnLoadComplete())
        await Promise.all(tasks)
        return
    }


    //</editor-fold>

    //<editor-fold desc = "Language Text operation">

    private async IHaveLanguageText_OnLoadComplete(): Promise<void> {
        const self = this

        // Header Record
        let txtRows = self.WB_DataObject.WB_DataObjectTextRows.filter((a) => a.isActive)
        let lt = new LanguageText({
            Id: self.WB_DataObject.cif.DATAOBJECT_ID,
            Name: self.WB_DataObject.cif.DATAOBJECT_NAME,
            LanguageFieldName: "LANGUAGE",
            RowKeyFieldName: "WB_DATAOBJECTT_ID",
            Rows: txtRows,
            TextFieldName: "TEXT",
            TooltipFieldName: "TOOLTIP",
            ShortTextFieldName: "SHORTTEXT",
            LoadFunction: async (arrLanguages): Promise<void> => {
                // Add missing records

                let dctByLanguage = _.keyBy(txtRows, (aRow) => aRow.cif.LANGUAGE)
                for (let aLanguage of arrLanguages) {
                    if (aLanguage in dctByLanguage)
                        continue
                    let rec = await self.addText(aLanguage)
                    lt.addRow(rec)
                }
            }
        })

        self.WB_DataObject.LanguageText = lt
        await lt.OnLoadComplete

        // Add Language Text for all the Column Record
        let colRows = self.WB_DataObject.WB_DataObjectColumnRows.filter((a) => a.isActive)
        await self.DataObjectColumn_setupIHaveLanguageText(colRows)

        // Add Language Text for all the Message Records
        let msgRows = self.WB_DataObject.WB_DataObjectMessageRows.filter((a) => a.isActive)
        await self.DataObjectMessage_setupIHaveLanguageText(msgRows)
    }

    private async DataObjectColumn_setupIHaveLanguageText(rows: WB_DataObjectColumnRow[]): Promise<void> {
        const self = this
        let tasks: Promise<any>[] = []

        for (let aUsage of ['Name', 'Group']) {
            for (let aDOCRow of rows) {
                let arrDOCTextRows = aDOCRow.WB_DataObjectColumnTextRows.filter((a) => a.isActive && (a.cif.USAGE == aUsage))
                let lt = new LanguageText({
                    Id: `${aDOCRow.cif.COLUMN_ID}_${aUsage}`,
                    Name: `${aDOCRow.cif.COLUMN_NAME} (${aUsage})`,
                    LanguageFieldName: "LANGUAGE",
                    RowKeyFieldName: "WB_DATAOBJECT_COLUMNT_ID",
                    Rows: arrDOCTextRows,
                    TextFieldName: "TEXT",
                    TooltipFieldName: "TOOLTIP",
                    ShortTextFieldName: "SHORTTEXT",
                    AbbreviationFieldName: "ABBREVIATION",
                    LoadFunction: async (arrLanguages): Promise<void> => {
                        // Add missing records
                        let dctByLanguage = _.keyBy(arrDOCTextRows, (aRow) => aRow.cif.LANGUAGE)
                        for (let aLanguage of arrLanguages) {
                            if (aLanguage in dctByLanguage)
                                continue
                            let rec = await self.addColumnText(aDOCRow, aUsage, aLanguage)
                            lt.addRow(rec)
                        }
                    }
                })

                switch (aUsage) {
                    case 'Name':
                        aDOCRow.LanguageText = lt
                        break;

                    case 'Group':
                        aDOCRow.LanguageTextGroup = lt
                        break;
                }
                tasks.push(lt.OnLoadComplete)
            }
        }

        await Promise.all(tasks)

    }

    private async DataObjectMessage_setupIHaveLanguageText(rows: WB_DataObjectMessageRow[]): Promise<void> {
        const self = this
        let tasks: Promise<any>[] = []

        for (let aDOMRow of rows) {
            let arrDOMTextRows = aDOMRow.WB_DataObjectMessageTextRows.filter((a) => a.isActive)

            let lt = new LanguageText({
                Id: aDOMRow.cif.MESSAGE_ID,
                Name: `${aDOMRow.cif.MESSAGE_ID} ${aDOMRow.cif.MESSAGE_TYPE}`,
                LanguageFieldName: "LANGUAGE",
                RowKeyFieldName: "WB_DATAOBJECT_MESSAGET_ID",
                Rows: arrDOMTextRows,
                TextFieldName: "TEXT",
                ShortTextFieldName: "SHORTTEXT",
                LoadFunction: async (arrLanguages): Promise<void> => {
                    // Add missing records
                    let dctByLanguage = _.keyBy(arrDOMTextRows, (aRow) => aRow.cif.LANGUAGE)
                    for (let aLanguage of arrLanguages) {
                        if (aLanguage in dctByLanguage)
                            continue
                        let rec = await self.addMessageText(aDOMRow, aLanguage)
                        lt.addRow(rec)
                    }
                }
            })

            aDOMRow.LanguageText = lt
            tasks.push(lt.OnLoadComplete)
        }

        await Promise.all(tasks)

    }

    //</editor-fold>

    //<editor-fold desc = "BO Changes operation">

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.WB_DataObject, opts)
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const dataobject_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        }

        const aRecResolver = new ESRecordResolver(dbContext, dataobject_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_DataObject, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

    //<editor-fold desc = "Add Remove operations">

    async addColumn(options?: any): Promise<WB_DataObjectColumnRow> {
        const self = this

        let aNewRow: WB_DataObjectColumnRow = <any>await self.dbContext.createRecordWithKey(esWB_DataObject_Column)
        aNewRow.setDefaults()
        aNewRow.cif.WB_DATAOBJECT_ID = self.drWB_DataObject.cif.WB_DATAOBJECT_ID
        aNewRow.WB_DataObjectRow = self.drWB_DataObject
        self.dbContext.add(esWB_DataObject_Column, aNewRow)

        await self.DataObjectColumn_setupIHaveLanguageText([aNewRow])
        return aNewRow
    }

    async removeColumn(aWbColumnId: number): Promise<WB_DataObjectColumnRow> {
        const self = this

        for (let aDOCRow of self.drWB_DataObject.WB_DataObjectColumnRows) {
            if (aDOCRow.isActive && aDOCRow.cif.WB_DATAOBJECT_COLUMN_ID == aWbColumnId) {
                aDOCRow.markDeleted()
                _.forEach(aDOCRow.WB_DataObjectColumnTextRows, (aRow) => {
                    if (!aRow.isActive)
                        return
                    aRow.markDeleted()
                })
                return aDOCRow
            }
        }

        return undefined
    }

    async addColumnText(aDOCRow: WB_DataObjectColumnRow, usage: string, languageCd: string): Promise<WB_DataObjectColumnTextRow> {
        const self = this

        // Check for duplicate
        for (let aRow of aDOCRow.WB_DataObjectColumnTextRows) {
            if (aRow.isActive && (aRow.cif.LANGUAGE == languageCd) && (aRow.cif.USAGE == usage))
                return aRow
        }

        let aNewRow: WB_DataObjectColumnTextRow = <any>await self.dbContext.createRecordWithKey(esWB_DataObject_Column_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_DATAOBJECT_COLUMN_ID = aDOCRow.cif.WB_DATAOBJECT_COLUMN_ID
        aNewRow.WB_DataObjectColumnRow = aDOCRow
        aNewRow.cif.LANGUAGE = languageCd
        aNewRow.cif.USAGE = usage
        self.dbContext.add(esWB_DataObject_Column_Text, aNewRow)
        return aNewRow
    }

    async removeColumnText(aWbColumnTextId: number): Promise<void> {
        const self = this

        let found = false
        _.forEach(self.drWB_DataObject.WB_DataObjectColumnRows, (aDOCRow) => {
            _.forEach(aDOCRow.WB_DataObjectColumnTextRows, (aDOCTRow) => {
                if (aDOCTRow.isActive && aDOCTRow.cif.WB_DATAOBJECT_COLUMNT_ID == aWbColumnTextId) {
                    aDOCTRow.markDeleted()
                    found = true
                    return false
                }
            })
            if (found)
                return false
        })

    }

    async addText(languageId: string): Promise<WB_DataObjectTextRow> {
        const self = this

        // Check for duplicate
        for (let aRow of self.WB_DataObject.WB_DataObjectTextRows) {
            if (aRow.isActive && (aRow.cif.LANGUAGE == languageId))
                return aRow
        }

        let aNewRow: WB_DataObjectTextRow = <WB_DataObjectTextRow>await self.dbContext.createRecordWithKey(esWB_DataObject_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_DATAOBJECT_ID = self.drWB_DataObject.cif.WB_DATAOBJECT_ID
        aNewRow.WB_DataObjectRow = self.drWB_DataObject
        aNewRow.cif.LANGUAGE = languageId
        self.dbContext.add(esWB_DataObject_Text, aNewRow)

        return aNewRow
    }

    async removeText(aWbTextId: number): Promise<void> {
        const self = this

        _.forEach(self.drWB_DataObject.WB_DataObjectTextRows, (aDataObjectTextRow: WB_DataObjectTextRow) => {
            if (aDataObjectTextRow.isActive && aDataObjectTextRow.cif.WB_DATAOBJECT_ID == aWbTextId) {
                aDataObjectTextRow.markDeleted()
            }
        })
    }


    async addMessage(options?: any): Promise<WB_DataObjectMessageRow> {
        const self = this

        let aNewRow: WB_DataObjectMessageRow = <any>await self.dbContext.createRecordWithKey(esWB_DataObject_Message)
        aNewRow.setDefaults()
        aNewRow.cif.WB_DATAOBJECT_ID = self.drWB_DataObject.cif.WB_DATAOBJECT_ID
        aNewRow.WB_DataObjectRow = self.drWB_DataObject
        self.dbContext.add(esWB_DataObject_Message, aNewRow)
        await self.DataObjectMessage_setupIHaveLanguageText([aNewRow])

        return aNewRow
    }

    async removeMessage(aWbMessageId: number): Promise<WB_DataObjectMessageRow> {
        const self = this

        for (let aDataObjectMessageRow of self.drWB_DataObject.WB_DataObjectMessageRows) {
            if (aDataObjectMessageRow.isActive && aDataObjectMessageRow.cif.WB_DATAOBJECT_MESSAGE_ID == aWbMessageId) {
                aDataObjectMessageRow.markDeleted()
                _.forEach(aDataObjectMessageRow.WB_DataObjectMessageTextRows, (aTR) => {
                    aTR.markDeleted()
                })
                return aDataObjectMessageRow
            }
        }
        return undefined
    }

    async addMessageText(aDOMR: WB_DataObjectMessageRow, languageCd: string): Promise<WB_DataObjectMessageTextRow> {
        const self = this

        // Check for duplicate
        for (let aRow of aDOMR.WB_DataObjectMessageTextRows) {
            if (aRow.isActive && (aRow.cif.LANGUAGE == languageCd))
                return aRow
        }

        let aNewRow: WB_DataObjectMessageTextRow = <any>await self.dbContext.createRecordWithKey(esWB_DataObject_Message_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_DATAOBJECT_MESSAGE_ID = aDOMR.cif.WB_DATAOBJECT_MESSAGE_ID
        aNewRow.WB_DataObjectMessageRow = aDOMR
        aNewRow.cif.LANGUAGE = languageCd
        self.dbContext.add(esWB_DataObject_Message_Text, aNewRow)
        return aNewRow
    }

    async removeMessageText(aWbMessageTextId: number): Promise<void> {
        const self = this

        let found = false
        _.forEach(self.drWB_DataObject.WB_DataObjectMessageRows, (aDataObjectMessageRow: WB_DataObjectMessageRow) => {
            _.forEach(aDataObjectMessageRow.WB_DataObjectMessageTextRows, (aDataObjectTextRow: WB_DataObjectMessageTextRow) => {
                if (aDataObjectTextRow.isActive && aDataObjectTextRow.cif.WB_DATAOBJECT_MESSAGET_ID == aWbMessageTextId) {
                    aDataObjectTextRow.markDeleted()
                    found = true
                    return false
                }
            })
            if (found)
                return false
        })

    }

    //</editor-fold>

    //<editor-fold desc = "Sync operations">

    async synchronizeDefinition(): Promise<void> {
        const self = this

        switch (self.WB_DataObject.cif.DATAOBJECT_TYPE) {
            case "Table":
                await self.synchronizeDefinitionUsingDbContext()
                await self.synchronizeDefinitionUsingEntity()
                self.setCustomColumnInd()
                break;

            case "View":
                await self.synchronizeDefinitionUsingEntity()

                break;

            case "UIControl":
            // Nothing Automatic
            case "UIView":
            // Nothing Automatic
        }

    }

    setCustomColumnInd() {
        const self = this

        let arrCustomColumn: TableCustomColumnsEntry[] = PAEnvironment.getValue(PAEnvironment.ESCustomColumns, [])
        let dctCustColumnTables = _.keyBy(arrCustomColumn, (a) => a.name)

        if (!(self.WB_DataObject.cif.DATAOBJECT_ID in dctCustColumnTables))
            return

        let dctColExisting: { [columnId: string]: WB_DataObjectColumnRow } = {}

        _.forEach(self.drWB_DataObject.WB_DataObjectColumnRows, aRow => {
            if (aRow.isActive) {
                dctColExisting[aRow.cif.COLUMN_ID] = aRow
            }
        })

        _.forEach(dctCustColumnTables[self.WB_DataObject.cif.DATAOBJECT_ID].properties, (aProperty, PropertyName) => {
            if (PropertyName in dctColExisting) {
                let row = dctColExisting[PropertyName]
                row.cif.CUSTOM_IND = '1'
            }
        })
    }

    // @ts-ignore
    async synchronizeDefinitionUsingDbContext(): Promise<void> {
        const self = this

        let dctColExisting: { [columnId: string]: WB_DataObjectColumnRow } = {}

        _.forEach(self.drWB_DataObject.WB_DataObjectColumnRows, aRow => {
            if (aRow.isActive) {
                dctColExisting[aRow.cif.COLUMN_ID] = aRow
            }
        })

        let mapper: ESRecordMapper = undefined

        _.forEach(<ESRecordMapper[]>self.dbContext._mappers, (aMapper: ESRecordMapper) => {
            let tableName = aMapper.TableName
            if (tableName == self.WB_DataObject.cif.DATAOBJECT_ID) {
                mapper = aMapper
                return false
            }
        })

        if (!mapper)
            return

        self.drWB_DataObject.cif.MAPPER_ID = mapper.name

        let dctLKs: { [id: string]: string } = _.keyBy(mapper.LogicalKeys, (a) => a)
        let dctFKs: { [id: string]: string } = {}

        _.forEach(mapper.ForeignKeys, (rel: jsdRelation) => {
            if (rel.type == Relation_BelongsTo)
                dctFKs[rel.foreignKey] = rel.relation
        })

        _.forEach(mapper.NonParentForeignkeys, (aMapperName, fieldName) => {
            dctFKs[fieldName] = aMapperName
        })

        await self.syncSchemaColumns(mapper.schema.properties, dctColExisting, dctFKs, dctLKs, {bSetMapperFlag: true})

    }

    async synchronizeDefinitionUsingEntity(): Promise<void> {
        const self = this

        let dctColExisting: { [columnId: string]: WB_DataObjectColumnRow } = {}
        let entity: PAEntity = new PAEntity()
        let schema: ISchema = undefined

        _.forEach(self.drWB_DataObject.WB_DataObjectColumnRows, aRow => {
            if (aRow.isActive) {
                dctColExisting[aRow.cif.COLUMN_ID] = aRow
            }
        })
        schema = await entity.getEntitySchema(0, self.WB_DataObject.cif.DATAOBJECT_ID)


        await self.syncSchemaColumns(schema.properties, dctColExisting, undefined, undefined, {bSetEntityFlag: true})


    }

    async syncSchemaColumns(schema: { [column_name: string]: IColumnSchema },
                            dctColExisting: { [columnId: string]: WB_DataObjectColumnRow },
                            dctFKs?: { [id: string]: string },
                            dctLKs?: { [id: string]: string },
                            options?: { bSetMapperFlag?: boolean, bSetEntityFlag?: boolean }): Promise<void> {
        const self = this
        let opts = options || {}

        for (let columnID in schema) {
            let columnSpec = schema[columnID]

            let columnRow: WB_DataObjectColumnRow = undefined
            if (columnID in dctColExisting)
                columnRow = dctColExisting[columnID];
            else {
                columnRow = await self.addColumn()
                columnRow.cif.COLUMN_ID = columnID
                columnRow.cif.COLUMN_NAME = columnID

                // Take some guesses here
                switch (true) {
                    case columnID.endsWith("_NAME"):
                        columnRow.cif.COLUMN_METATYPE = 'name'
                        columnRow.cif.DISPLAYTYPE = 'text'
                        break;

                    case columnID.endsWith("_COMMENTS"):
                        columnRow.cif.DISPLAYTYPE = 'textarea'
                        break;

                    case columnID.endsWith("_IND"):
                        columnRow.cif.DISPLAYTYPE = 'boolean'
                        break;

                    case columnID.endsWith("_DT"):
                        columnRow.cif.DISPLAYTYPE = 'date'
                        break;

                    case columnID.endsWith("_TS"):
                        columnRow.cif.DISPLAYTYPE = 'time'
                        break;

                    case columnID.endsWith("_DTTS"):
                        columnRow.cif.DISPLAYTYPE = 'datetime'
                        break;

                    case (columnSpec.type == "number") && columnID.endsWith("_ID"):
                    case (columnSpec.type == "number") && columnID.includes("_ID_"):
                        columnRow.cif.DISPLAYTYPE = 'relation'
                        break;

                    case (columnID == "RENDER_OPTIONS"):
                        columnRow.cif.DISPLAYTYPE = 'json'
                        break;

                    case (columnSpec.type == "string"):
                        columnRow.cif.DISPLAYTYPE = 'text'
                        break;

                    case (columnSpec.type == "number") && columnID.includes("SPEND"):
                    case (columnSpec.type == "number") && columnID.includes("RTLSLS"):
                    case (columnSpec.type == "number") && columnID.includes("LISTSLS"):
                    case (columnSpec.type == "number") && columnID.includes("COSTS"):
                    case (columnSpec.type == "number") && columnID.includes("PRICE"):
                        columnRow.cif.DISPLAYTYPE = 'currency'
                        break;

                    case (columnSpec.type == "number"):
                        columnRow.cif.DISPLAYTYPE = 'number'
                        break;


                }

            }
            if (columnSpec.id)
                columnRow.cif.COLUMN_METATYPE = 'id'

            if ('hdb' in columnSpec) {
                columnRow.cif.COLUMN_DATATYPE = columnSpec.hdb.dataType
                columnRow.cif.COLUMN_LENGTH = columnSpec.hdb.dataLength
                columnRow.cif.COLUMN_PRECISION = columnSpec.hdb?.dataScale || 0
            }

            if ((dctFKs) && (columnID in dctFKs)) {
                columnRow.cif.FOREIGNKEY_IND = '1'
                // Could look up the PK of the target Entity
            }

            if ((dctLKs) && (columnID in dctLKs)) {
                columnRow.cif.LOGICALKEY_IND = '1'
            }

            if (opts.bSetMapperFlag)
                columnRow.cif.MAPPER_IND = '1'

            if (opts.bSetEntityFlag)
                columnRow.cif.ENTITY_SERVICE_IND = '1'

        }
    }

    async addColumnsUsingPropertiesFile(fileContents: string, sLanguageId?: string) {

    }

    get Properties(): string {
        // Go through columns and output the properties files in the default language
        return this.getPropertiesForLanguage('en')
    }

    getPropertiesForLanguage(sLanguageId?: string): string {
        return ""
    }

    //</editor-fold>

};
PAEnvironment.registerBusinessObjectClass(DataObjectBO, "DataObjectBO", "Data Object")